import React from "react";
import {ProjectOrderByContext} from "./project-order-by-context-props.ts";

const useProjectOrderByContext = () => {
    const context = React.useContext(ProjectOrderByContext);
    if (context === undefined) {
        throw new Error('useProjectOrderByContext must be used within a ProjectOrderByProvider');
    }
    return context;
};

export default useProjectOrderByContext;